export default function PageHeader({
  title,
  subtitle,
  action,
  children,
  className = "",
}) {
  return (
    <div className={`mb-6 ${className}`}>
      {/* Stack on small screens, flex on medium+ */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-4">
        <div>
          {/* Responsive heading sizes */}
          <h1 className="text-2xl md:text-3xl font-bold text-text">{title}</h1>
          {subtitle && (
            <p className="mt-2 text-sm md:text-base text-text opacity-70">
              {subtitle}
            </p>
          )}
        </div>

        {/* Action button aligns right on larger screens, stacks below on mobile */}
        {action && <div className="flex-shrink-0 md:self-start">{action}</div>}
      </div>

      {/* Children content below header */}
      <div className="mt-4">{children}</div>
    </div>
  );
}
